module.exports = __webpack_public_path__ + "img/DE05836.008243c1.png";